import BlockRange from '@intercom/embercom-composer/blocks/block-range';
let topLevelDomains = ['.aero', '.biz', '.cat', '.com', '.coop', '.edu', '.gov', '.info', '.int', '.jobs', '.mil', '.mobi', '.museum', '.name', '.net', '.org', '.travel', '.ac', '.ad', '.ae', '.af', '.ag', '.ai', '.al', '.am', '.an', '.ao', '.aq', '.ar', '.as', '.at', '.au', '.aw', '.az', '.ba', '.bb', '.bd', '.be', '.bf', '.bg', '.bh', '.bi', '.bj', '.bm', '.bn', '.bo', '.br', '.bs', '.bt', '.bv', '.bw', '.by', '.bz', '.ca', '.cc', '.cd', '.cf', '.cg', '.ch', '.ci', '.ck', '.cl', '.cm', '.cn', '.co', '.cr', '.cs', '.cu', '.cv', '.cx', '.cy', '.cz', '.de', '.dj', '.dk', '.dm', '.do', '.dz', '.ec', '.ee', '.eg', '.eh', '.er', '.es', '.et', '.eu', '.fi', '.fj', '.fk', '.fm', '.fo', '.fr', '.ga', '.gb', '.gd', '.ge', '.gf', '.gg', '.gh', '.gi', '.gl', '.gm', '.gn', '.gp', '.gq', '.gr', '.gs', '.gt', '.gu', '.gw', '.gy', '.hk', '.hm', '.hn', '.hr', '.ht', '.hu', '.id', '.ie', '.il', '.im', '.in', '.io', '.iq', '.ir', '.is', '.it', '.je', '.jm', '.jo', '.jp', '.ke', '.kg', '.kh', '.ki', '.km', '.kn', '.kp', '.kr', '.kw', '.ky', '.kz', '.la', '.lb', '.lc', '.li', '.lk', '.lr', '.ls', '.lt', '.lu', '.lv', '.ly', '.ma', '.mc', '.md', '.mg', '.mh', '.mk', '.ml', '.mm', '.mn', '.mo', '.mp', '.mq', '.mr', '.ms', '.mt', '.mu', '.mv', '.mw', '.mx', '.my', '.mz', '.na', '.nc', '.ne', '.nf', '.ng', '.ni', '.nl', '.no', '.np', '.nr', '.nu', '.nz', '.om', '.pa', '.pe', '.pf', '.pg', '.ph', '.pk', '.pl', '.pm', '.pn', '.pr', '.ps', '.pt', '.pw', '.py', '.qa', '.re', '.ro', '.ru', '.rw', '.sa', '.sb', '.sc', '.sd', '.se', '.sg', '.sh', '.si', '.sj', '.sk', '.sl', '.sm', '.sn', '.so', '.sr', '.st', '.su', '.sv', '.sy', '.sz', '.tc', '.td', '.tf', '.tg', '.th', '.tj', '.tk', '.tm', '.tn', '.to', '.tp', '.tr', '.tt', '.tv', '.tw', '.tz', '.ua', '.ug', '.uk', '.um', '.us', '.uy', '.uz', '.va', '.vc', '.ve', '.vg', '.vi', '.vn', '.vu', '.wf', '.ws', '.ye', '.yt', '.yu', '.za', '.zm', '.zr', '.zw'];
let tldRegex = `(\\${topLevelDomains.join('|\\')})`;
let regexPattern = `\\b(((http(s)?)?:\\/\\/)?[^\\s]{2,}${tldRegex}+[^\\s]{0,})`;
let linkRegex = new RegExp(`${regexPattern}\\s`, 'gi');
function LinkReplacer(block) {
  this.block = block;
}
LinkReplacer.prototype = {
  replaceLinksAtIndex(index, delimiter) {
    let text = this.block.get('text').slice(0, index);
    let match = delimiter.exec(text);
    let startIndex = 0;
    if (match) {
      startIndex = match.index;
    }
    text = text.slice(startIndex);
    this._replaceLinks(linkRegex, text, startIndex);
  },
  replaceLinks(options) {
    let originalText = this.block.get('text');
    this.mutationResult = options && options.mutationResult;
    this._replaceLinks(linkRegex, originalText);
  },
  _replaceLinks(regex, text, offset) {
    let match;
    offset = offset || 0;
    while (match = regex.exec(text)) {
      if (this._isPossiblyAMarkdownLink(match, text) || !this._checkIfTextContainsTopLevelDomain(match[1])) {
        return;
      }
      offset = this._processMatch(match, offset);
    }
    regex.lastIndex = 0;
  },
  _processMatch(match, offset) {
    let urlText = match[1];
    let href = this._cleanUpHref(urlText);
    href = this._prependProtocol(href);
    let blockRange = this._blockRangeForMatch(match);
    if (this._shouldReplaceMatch(match, blockRange)) {
      this._addAnchor(blockRange, href);
      this._updateMutationResult();
    }
    return offset + urlText.length;
  },
  _blockRangeForMatch(match) {
    let urlMatch = match[1];
    let startIndex = match.index;
    let endIndex = startIndex + urlMatch.length;
    return BlockRange.atPositionIndex(startIndex, endIndex);
  },
  _addAnchor(blockRange, href) {
    let options = {
      href
    };
    this.block.addEntity('anchor', blockRange, options);
    return false;
  },
  _shouldReplaceMatch(match, blockRange) {
    return !this._matchShouldBeSkipped(match) && !this._existingEntitiesInRange(blockRange);
  },
  _matchShouldBeSkipped(match) {
    return this.block.get('replacementsToSkip') && this.block.get('replacementsToSkip').includes(match[1]);
  },
  _existingEntitiesInRange(blockRange) {
    let entities = this.block.get('entities').withinRange(blockRange);
    let entity;
    for (let i = 0; i < entities.length; i++) {
      entity = entities.objectAt(i);
      if (entity && entity.get('type') === 'anchor' || entity.get('type') === 'attribute') {
        return true;
      }
    }
    return false;
  },
  _updateMutationResult() {
    let mutationResult = this.mutationResult;
    if (mutationResult) {
      mutationResult.set('shouldRerender', true);
    }
  },
  _cleanUpHref(href) {
    return href.replace(/(\.|;|:|\.\.\.|\?|!|"|')\s?$/, '');
  },
  _isPossiblyAMarkdownLink(match, text) {
    return /\(|\)|\[|\]/.test(text.substring(match.index));
  },
  _isEmailAddress(href) {
    return /@/.test(href) && new RegExp(`${tldRegex}$`).test(href);
  },
  _prependProtocol(href) {
    if (this._isEmailAddress(href) && !/(\/|mailto:)/.test(href)) {
      return `mailto:${href}`;
    }
    if (href.indexOf('://') === -1 && href.indexOf('mailto:') === -1) {
      return `http://${href}`;
    }
    return href;
  },
  _checkIfTextContainsTopLevelDomain(text) {
    let url = this._prependProtocol(text);
    let parser = document.createElement('a');
    parser.href = url;
    if (parser.host) {
      let hostParts = parser.host.split('.').filter(function (part) {
        return part !== '';
      });
      let tld = hostParts.pop();
      tld = `.${this._getOnlyTLD(tld)}`;
      return topLevelDomains.indexOf(tld) > -1;
    } else {
      return this._lookForTLDByPeriodSplitting(text);
    }
  },
  _lookForTLDByPeriodSplitting(text) {
    let tld;
    let tldPosition;
    let periodSplit = text.split('.');
    if (!periodSplit || periodSplit.length < 2 || periodSplit.length === 2 && periodSplit[0] === '') {
      return false;
    }
    //Find the tld position in case there is a full stop
    tldPosition = periodSplit[periodSplit.length - 1].length ? periodSplit.length - 1 : periodSplit.length - 2;
    tld = periodSplit[tldPosition];
    tld = `.${this._getOnlyTLD(tld)}`;
    return topLevelDomains.indexOf(tld) > -1;
  },
  _getOnlyTLD(text) {
    return text.replace(/(>|<|!|;|:|\/|&|\?|%2(F|6)|%3E|\.$|\.?\s).*/, '');
  }
};
export default LinkReplacer;